import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { BinCrudService } from 'src/app/shared/services/bin-crud.service';
import { Bin } from 'src/app/shared/interfaces/bin';
import { BinLocationCrudService } from '../shared/services/bin-location-crud.service';
import { BinLocation as Location } from 'src/app/shared/interfaces/bin-location';
import { GrapeVariety } from '../shared/interfaces/grape-variety';
import { GrapeVarietyCrudService } from '../shared/services/grape-variety-crud.service';
import { BinArchiveCrudService } from '../shared/services/bin-archive-crud.service';
import { Brand } from '../shared/interfaces/brand';
import { BrandCrudService } from '../shared/services/brand-crud.service';

@Component({
  selector: 'app-bins-archive',
  templateUrl: './bins-archive.component.html',
  styleUrls: ['./bins-archive.component.scss']
})
export class BinsArchiveComponent implements OnInit {

  bins: Bin[];
  bin: Bin;
  selectedBins: Bin[] = [];

  binDialog: boolean = false;

  submitted: boolean = false;

  locations: Location[];
  locationsMap : Map<string,Location>;

  grapeVarieties: GrapeVariety[];
  grapeVarietiesMap : Map<string,GrapeVariety>;

  brands: Brand[];
  brandsMap : Map<string,Brand>;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private binService : BinCrudService,
    private binArchiveService : BinArchiveCrudService,
    private binBrandService : BrandCrudService,
    private locationService: BinLocationCrudService,
    private grapeVarietyService: GrapeVarietyCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Bin Management'},
      {label: 'Bins (Archive)'}
    ];

    this.bins = [];
    this.bin = { } as Bin ;

    this.locations = [];
    this.locationsMap = new Map<string,Location>();

    this.grapeVarieties = [];
    this.grapeVarietiesMap = new Map<string,GrapeVariety>();

    this.brands = [];
    this.brandsMap = new Map<string,Brand>();
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.binArchiveService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.bins = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Bin = jsonItem as Bin;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.bins.push(l);
        }
      })
    });

    let loc = this.locationService.getLocationsList(); 
    loc.snapshotChanges().subscribe(data => {
      this.locations = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Location = jsonItem as Location;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          if ( l.isEnabled ) { 
            this.locations.push(l);
            
          }
          this.locationsMap.set( l.$key , l);
         
        }
      });
      this.locations = this.locations.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);
    });

    let c = this.grapeVarietyService.getList(); 
    c.snapshotChanges().subscribe(data => {
      this.grapeVarieties = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : GrapeVariety = jsonItem as GrapeVariety;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          if ( l.isEnabled ) { 
            this.grapeVarieties.push(l);
          }
          this.grapeVarietiesMap.set( l.$key , l);
        }
      });
      this.grapeVarieties = this.grapeVarieties.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);
    });

    let b = this.binBrandService.getList(); 
    b.snapshotChanges().subscribe(data => {
      this.brands = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Brand = jsonItem as Brand;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          if ( l.isEnabled ) { 
            this.brands.push(l);
          }
          this.brandsMap.set( l.$key , l);
        }
      });
      this.brands = this.brands.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);
    });

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'location', header: 'Location' },
      { field: 'grapeVariety', header: 'Grape variety' },
      { field: 'quantity', header: 'Quantity' },
      { field: 'nbOfUses', header: 'Cycles' },
      { field: 'brand', header: 'Brand' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'nbOfUses');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'brand');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.binService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.bins);
            doc.save('bins.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.bins);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "bins");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedBins);
      // console.log('SAVEC CSV LOCATIONS ', this.bins);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedBins, 'bins', exportCols);
   // this.exportService.exportToCsv(this.bins, 'bins', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.bin = {} as Bin;
    this.submitted = false;
    this.binDialog = true;
  }

  deleteSelectedBins() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected bins?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.bins = this.bins.filter(val => !this.selectedBins.includes(val));
           
            this.selectedBins.forEach( bin => this.binService.delete(bin.$key));
            this.selectedBins = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Binss Deleted', life: 3000});
        }
    });
  }

  editBin(bin: Bin) {
    this.bin = {...bin};
    this.binDialog = true;
  }

  deleteBin(bin: Bin) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + bin.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.bins = this.bins.filter(val => val.$key !== bin.$key);
            this.bin = {} as Bin;
            this.binService.delete(bin.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Bin Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.binDialog = false;
    this.submitted = false;
  }

  saveBin() {
    this.submitted = true;

    if ( this.bin.name.trim() ) {
      this.bin.isEnabled = true;
      
      if (this.bin.$key) {
          this.bins[this.findIndexById(this.bin.$key)] = this.bin;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Bin Updated', life: 3000});
          this.binService.update(this.bin);
        } else {
          this.bin.position = this.bins.length;
          this.binService.add(this.bin);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Bin Created', life: 3000});
      this.bins = [...this.bins];
    }

    this.binDialog = false;
    this.bin = { } as Bin;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.bins.length; i++) {
        if (this.bins[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeBin(bin : Bin) {
    //console.log("SAVE", bin);
    this.binService.update(bin);
  }

  completePosition(bin : Bin) {
   // console.log("SAVE", bin);
  //  this.binService.updateBin(bin);


    if ( this.newPosition > -1 ) {
        bin.position = this.newPosition;
        bin = this.checkPositionLimits(bin);
        this.reorderElements(bin);
        //this.updateDB(bin);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.bins);
    // const myClonedArray = [];
    // this.bins.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.bins.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.bins.length - 1 - event.dropIndex;
    const binToMove = this.bins[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.bins[index] = this.bins[index+1];
        this.bins[index].position = index;
        this.binService.update(this.bins[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.bins[index] = this.bins[index-1];
        this.bins[index].position = index;
        this.binService.update(this.bins[index]);
      }
    } 
    this.bins[endIndex] = binToMove;
    this.bins[endIndex].position = endIndex;
    this.binService.update(this.bins[endIndex]);
  }

  // onFieldEdit(bin: Spray, fieldName: string): void {
  //   //console.log(this.bins);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + bin[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       bin.position = this.newPosition;
  //       bin = this.checkPositionLimits(bin);
  //       this.reorderElements(bin);
  //       //this.updateDB(bin);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(bin);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.bins.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, bin: Bin) {
    // console.log("event" +event);
    if (bin.position != null && bin.position > -1) {
      this.previousPosition = bin.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(bin: Bin) {
    console.log('check ',bin.position + ' ' + this.bins.length);
    if (!bin.position) {
     // console.log('check 1');
      return this.bin;
    }
    if (bin.position < 0) {
      bin.position = 0;
      // console.log('check 2');
      return bin;
    }
    if (bin.position > this.bins.length) {
      bin.position = this.bins.length - 1;
    //  console.log('check 3', bin.position);
      return bin;
    }
   // console.log('check 4');
    return bin;
  }

  async reorderElements(bin: Bin) {
    this.newPosition = this.newPosition  > this.bins.length ? this.bins.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === bin.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const binToMove = this.bins[startIndex];
   // console.log('Item to move: ', this.bins[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.bins);
        console.log('Item to +1: ', this.bins[index+1]);

        this.bins[index] = this.bins[index+1];
        this.bins[index].position = index;
        // console.log('Move: ', this.bins[index+1]);
        // console.log('Move pos: ', this.bins[index].position);
        //await this.updateDB(this.bins[index]);
        this.binService.update(this.bins[index]);
     //   console.log('Update DB: ', this.bins[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.bins[index] = this.bins[index-1];
        this.bins[index].position = index;
        this.binService.update(this.bins[index]);
      }
    } 
    this.bins[endIndex] = binToMove;
    this.bins[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.binService.update(this.bins[endIndex]);
    
    // const myClonedArray = [];
    // this.bins.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.bins = myClonedArray;
   // this.getAllRecords();
  }

  onChangeLocation(barrel: Bin, barrelLocationKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = barrelLocationKey;
    // console.log('new key wanted',  newBarrelKey);
    // console.log('before key ', previousBarrelKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousKey && newKey) {

      const newLocation = this.locationsMap.get(newKey) || {} as Location;
      const newLocationName = newLocation.name;
        
      barrel.locationKey = newKey;
      barrel.locationName = newLocationName;
      this.binService.update(barrel);
      return true;

    }

    if (previousKey && !newKey) {
      barrel.locationKey = '';
      barrel.locationName = '';
      this.binService.update(barrel);
      return true;
    }

    const newLocation = this.locationsMap.get(newKey) || {} as Location;
    const newLocationName = newLocation.name;
        
    barrel.locationKey = newKey;
    barrel.locationName = newLocationName;
    this.binService.update(barrel);
    return true;
  }


  onChangeGrapeVariety(bin: Bin, grapeVarietyKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = grapeVarietyKey;
    // console.log('new key wanted',  newBarrelKey);
    // console.log('before key ', previousBarrelKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousKey && newKey) {

      const newCooper = this.grapeVarietiesMap.get(newKey) || {} as GrapeVariety;
      const newCooperName = newCooper.name;
        
      bin.grapeVarietyKey = newKey;
      bin.grapeVarietyName = newCooperName;
      this.binService.update(bin);
      return true;

    }

    if (previousKey && !newKey) {
      bin.grapeVarietyKey = '';
      bin.grapeVarietyName = '';
      this.binService.update(bin);
      return true;
    }

    const newCooper = this.grapeVarietiesMap.get(newKey) || {} as GrapeVariety;
    const newCooperName = newCooper.name;
        
    bin.grapeVarietyKey = newKey;
    bin.grapeVarietyName = newCooperName;
    this.binService.update(bin);
    return true;
  }

  onChangeBrand(bin: Bin, brandKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = brandKey;
    // console.log('new key wanted',  newBarrelKey);
    // console.log('before key ', previousBarrelKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousKey && newKey) {

      const newCooper = this.brandsMap.get(newKey) || {} as Brand;
      const newCooperName = newCooper.name;
        
      bin.brandKey = newKey;
      bin.brandName = newCooperName;
      this.binBrandService.update(bin);
      return true;

    }

    if (previousKey && !newKey) {
      bin.brandKey = '';
      bin.brandName = '';
      this.binBrandService.update(bin);
      return true;
    }

    const newCooper = this.brandsMap.get(newKey) || {} as Brand;
    const newCooperName = newCooper.name;
        
    bin.brandKey = newKey;
    bin.brandName = newCooperName;
    this.binBrandService.update(bin);
    return true;
  }


  // ARCHIVE
  unarchiveSelectedBins() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to unarchive the selected bins?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.bins = this.bins.filter(val => !this.selectedBins.includes(val));
            
            this.selectedBins.forEach( bin => {
              try {
                let p : Partial<Bin>= {
                  ...bin
                }
                if (p.$key) {
                  delete p.$key;
                }
                this.binService.add(p as Bin);
                this.binArchiveService.delete(bin.$key);
              } catch (e) {
                console.error(bin);
                console.error(e);
              }
              
            } );
            
            this.selectedBins = [];

            //this.pallets = this.pallets.filter(val => val.$key !== pallet.$key);
  
            
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Bins Unarchived', life: 3000});
        }
    });
  }

  archiveBin(bin: Bin) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to archive ' + bin.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.bins = this.bins.filter(val => val.$key !== bin.$key);
            
            try {
              let p : Partial<Bin>= {
                ...bin
              }
              if (p.$key) {
                delete p.$key;
              }
              this.binArchiveService.add(p as Bin);
              //this.palletService.DeletePallet(pallet.$key);
            } catch (e) {
              console.error(bin);
              console.error(e);
            }
            this.bin = {} as Bin;
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Bin Archived', life: 3000});
        }
    });
  }

  computeQuantity() : number{
    let total : number = Number(0);
    this.selectedBins.forEach( bin => {
      if (bin.quantity) {
        let i : number = bin.quantity as number;
        total += Number(i);
      }
    });
    return total;
  }

  // computeClients() : string[] {
  //   let results : string[] = [];
  //   this.selectedBins.forEach( bin => {
  //     if (bin.clientName) {
  //       if (!results.includes(bin.clientName)) {
  //         results.push(bin.clientName);
  //       }
  //     }
  //   });
  //   return results;
  // }

  computeLocations() : string[] {
    let results : string[] = [];
    this.selectedBins.forEach( bin => {
      if (bin.locationName) {
        if (!results.includes(bin.locationName)) {
          results.push(bin.locationName);
        }
      }
    });
    return results;
  }

  recycle(bin: Bin) {
    if (!bin.nbOfuses) {
      bin.nbOfuses = 1;
    }
    bin.nbOfuses++;
    this.completeBin(bin);
  }
}